{
    "name": "@interopio/bridge",
    "version": "0.1.0-beta.0",
    "license": "see license in license.md",
    "author": "interop.io",
    "homepage": "https://docs.interop.io/bridge",
    "keywords": [
        "io.bridge",
        "bridge",
        "io.connect",
        "glue42",
        "interop.io"
    ],
    "repository": {
        "type": "git",
        "url": "https://github.com/InteropIO/bridge.git",
        "directory": "packages/bridge"
    },
    "type": "module",
    "exports": {
        "./package.json": "./package.json",
        ".": {
            "default": "./dist/index.js"
        },
        "./main": {
            "import": {
                "types": "./types/main.d.ts",
                "default": "./dist/main.js"
            }
        }
    },
    "bin": {
        "bridge": "./bin/bridge.js"
    },
    "scripts": {
        "test": "mocha test --recursive",
        "build:types": "tsc --declaration --emitDeclarationOnly --outDir types",
        "build:main": "esbuild src/main.mts --outdir=dist --bundle --packages=external --sourcemap --platform=node --format=esm --target=node20.15",
        "build:index": "esbuild src/index.ts --outdir=dist --target=node20.15",
        "build": "npm run build:main && npm run build:index"
    },
    "dependencies": {
        "@interopio/gateway-server": "^0.13.0-beta.1",
        "dotenv": "^17.2.3",
        "jsrsasign": "^11.1.0",
        "nanoid": "^5.1.6"
    },
    "devDependencies": {
        "@interopio/gateway": "^0.16.1-beta.0",
        "@types/jsrsasign": "^10.5.15",
        "@types/ws": "^8.18.1",
        "rand-seed": "^3.0.0"
    },
    "engines": {
        "node": ">= 20.15 || >=22.2.0 || >=24.0"
    }
}
